const PIXEL_ID = '1322788416056310'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      loaded?: boolean
      version?: string
      push?: unknown
    }
    _fbq?: unknown
  }
}

/**
 * Carga el pixel cuando el navegador está libre (o ante la primera
 * interacción), para que no compita con el renderizado en móviles.
 */
export function initMetaPixelWhenIdle() {
  if (typeof window === 'undefined' || window.fbq) return

  let started = false
  const start = () => {
    if (started) return
    started = true
    window.removeEventListener('pointerdown', start)
    window.removeEventListener('scroll', start)
    initMetaPixel()
  }

  window.addEventListener('pointerdown', start, { once: true, passive: true })
  window.addEventListener('scroll', start, { once: true, passive: true })

  if ('requestIdleCallback' in window) {
    ;(window as unknown as {
      requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void
    }).requestIdleCallback(start, { timeout: 3000 })
  } else {
    setTimeout(start, 2000)
  }
}

/** Inyecta el Meta Pixel una sola vez y registra el PageView inicial. */
export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq!.callMethod) {
      fbq!.callMethod.apply(fbq, args)
    } else {
      fbq!.queue!.push(args)
    }
  } as NonNullable<Window['fbq']>

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.alt = ''
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')
}

/** Registra un evento estándar del pixel (ej.: InitiateCheckout). */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
) {
  // Si el usuario compra antes de que el pixel cargue, lo iniciamos ahí mismo.
  initMetaPixel()
  window.fbq?.('track', event, params)
}
